export class AutofillProfile {

    constructor(
        public profileId: string,
        public name: string,
        public site: string,
        public hotkey: string
    ){}
}
